import {
  useQuery,
  useMutation,
  type UseQueryResult,
  type UseMutationResult,
} from '@tanstack/react-query';
import { queryKeys } from '@/lib/query-keys';
import {
  getAlerts,
  getAlertSummary,
  resolveAlert,
  type Alert,
  type AlertFilters,
  type AlertsResponse,
  type AlertSummary,
} from '@/services/alert.service';

export function useAlerts(
  factoryId: string,
  filters?: AlertFilters
): UseQueryResult<AlertsResponse> {
  return useQuery<AlertsResponse>({
    queryKey: queryKeys.alerts.list(factoryId, filters as Record<string, unknown>),
    queryFn: () => getAlerts(factoryId, filters),
    staleTime: 30 * 1000,
    refetchInterval: 30_000,
    enabled: !!factoryId,
  });
}

export function useAlertSummary(factoryId: string): UseQueryResult<AlertSummary> {
  return useQuery<AlertSummary>({
    queryKey: queryKeys.alerts.summary(factoryId),
    queryFn: () => getAlertSummary(factoryId),
    staleTime: 30 * 1000,
    enabled: !!factoryId,
  });
}

export function useResolveAlert(
  factoryId: string
): UseMutationResult<{ alert: Alert }, Error, number> {
  return useMutation<{ alert: Alert }, Error, number>({
    mutationFn: (alertId: number) => resolveAlert(factoryId, alertId),
  });
}
